module.exports = __webpack_public_path__ + "static/img/11.6a0fd4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/11.png
// module id = jGLg
// module chunks = 0